var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('span',[_vm._v("Bạn có công việc")]),_vm._v(" "),_c('span',{staticClass:"highlight font-weight__bold"},[_vm._v(" "+_vm._s(_vm.taskTitle)+" ")]),_vm._v(" "),_c('span',{class:['highlight-action', _vm.remainingDay >= 0 ? 'warning' : 'alert']},[_vm._v("\n    "+_vm._s(_vm.state)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c2e7720","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/notification-item-quahan-cv.vue
// module id = null
// module chunks = 